// extracted by mini-css-extract-plugin
module.exports = {"control":"Dropdown_control","body":"Dropdown_body","notification":"Dropdown_notification"};